import Vue from 'vue'
import Element from 'element-ui'
import '../assets/css/element-variables.scss'
import Contextmenu from "vue-contextmenujs"
// import uCharts from '@qiun/uni-ucharts'
Vue.use(Contextmenu);
Vue.use(Element)
// Vue.component('qiun-data-charts',uCharts)
